import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-area: button;\n  height: 22px;\n  min-height: 22px;\n  padding: 0 4px;\n  width: 90%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  grid-area: toggle;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: #191919;\n  font-size: 14px;\n  font-weight: 600;\n  grid-area: label;\n  line-height: 20px;\n  margin-right: 5px;\n  min-width: 200px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas: 'label toggle button';\n  grid-template-columns: 2fr 0.5fr 0.5fr;\n  grid-template-rows: 1fr;\n  max-width: 510px;\n  width: 100%;\n\n  @media screen and (min-width: ", "px) {\n    display: grid;\n    grid-template-areas: 'label toggle button';\n    grid-template-columns: 2fr 0.5fr 0.5fr;\n    grid-template-rows: 1fr;\n    justify-content: space-between;\n  }\n\n  @media screen and (max-width: ", "px) {\n    display: grid;\n    grid-template-areas:\n      'label label'\n      'toggle button';\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    margin-top: 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import { styled, Button, OptionToggle } from '@acorns/web-components';
import { useFeature } from '@optimizely/react-sdk';
import { style } from '../../../../theme';
var StyledFeatureContainer = styled.div(_templateObject(), style(function (theme) {
  return theme.breakpoints.sm + 1;
}), style(function (theme) {
  return theme.breakpoints.sm;
}));
var StyledLabel = styled.label(_templateObject2());
var StyledToggleWrapper = styled.div(_templateObject3());
var StyledButton = styled(Button)(_templateObject4());
var OPTIMIZELY_OVERRIDE = 'optimizely_feature_override:';

var FeatureToggle = function FeatureToggle(_ref) {
  var featureName = _ref.featureName;

  var _useFeature = useFeature(featureName),
      _useFeature2 = _slicedToArray(_useFeature, 1),
      optimizelyStatus = _useFeature2[0];

  var _useState = useState(window.localStorage.getItem("".concat(OPTIMIZELY_OVERRIDE).concat(featureName)) || ''),
      _useState2 = _slicedToArray(_useState, 2),
      featureState = _useState2[0],
      setFeatureStatus = _useState2[1];

  var isDefault = featureState === '';

  var handleStatusChange = function handleStatusChange(toggleValue) {
    if (toggleValue === '') return window.localStorage.removeItem("".concat(OPTIMIZELY_OVERRIDE).concat(featureName));
    return window.localStorage.setItem("".concat(OPTIMIZELY_OVERRIDE).concat(featureName), toggleValue);
  };

  var handleToggle = function handleToggle(_ref2) {
    var checked = _ref2.target.checked;
    var nextState = checked ? 'true' : 'false';
    setFeatureStatus(nextState);
    handleStatusChange(nextState);
  };

  var handleReset = function handleReset() {
    setFeatureStatus('');
    handleStatusChange('');
  };

  return /*#__PURE__*/React.createElement(StyledFeatureContainer, null, /*#__PURE__*/React.createElement(StyledLabel, null, featureName), /*#__PURE__*/React.createElement(StyledToggleWrapper, null, /*#__PURE__*/React.createElement(OptionToggle, {
    checked: isDefault ? optimizelyStatus : featureState === 'true',
    icons: false,
    onChange: handleToggle
  })), /*#__PURE__*/React.createElement(StyledButton, {
    disabled: isDefault,
    onPress: handleReset
  }, "Reset"));
};

export default FeatureToggle;